import { render, staticRenderFns } from "./CoreCard.vue?vue&type=template&id=1eff35a1&lang=pug&"
import script from "./CoreCard.vue?vue&type=script&lang=js&"
export * from "./CoreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports